module.exports = __webpack_public_path__ + "./favicons/apple-icon-57x57.png";